import React, { useState, useEffect } from "react"
import PropTypes from "prop-types"
import Slider from "infinite-react-carousel"

const MetaCarousel = ({ children, itemsToShow, ...params }) => {
  const [isSlider, setisSlider] = useState(false)
  useEffect(() => {
    setisSlider(true)
  }, [])
  return (
    <>
      {isSlider && (
        <Slider slidesToShow={itemsToShow} {...params}>
          {children}
        </Slider>
      )}
    </>
  )
}

MetaCarousel.propTypes = {
  autoplay: PropTypes.bool,
  autoplayScroll: PropTypes.number,
  autoplaySpeed: PropTypes.number,
  slidesPerRow: PropTypes.number,
  duration: PropTypes.number,
  dots: PropTypes.bool,
  arrows: PropTypes.bool,
  swipe: PropTypes.bool,
  itemsToShow: PropTypes.number,
}

MetaCarousel.defaultProps = {
  autoplay: true,
  autoplayScroll: 1,
  autoplaySpeed: 3000,
  slidesPerRow: 1,
  duration: 300,
  dots: false,
  arrows: false,
  swipe: false,
  itemsToShow: 7,
}

export default MetaCarousel
